import Box from '@mui/material/Box';
import TextField from '../../../../../../../../temp/TextField';
import IconButton from '@mui/material/IconButton';
import CancelIcon from '@mui/icons-material/Cancel';
import SaveIcon from '@mui/icons-material/Save';
import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';

type EditSellerInfoProps = {
    value: string;
    onCancel: () => void;
    onSave: (value: string) => void;
    tooltipCancel: string;
    tooltipSave: string;
};

export function EditSellerInfo({ value, onCancel, onSave, tooltipCancel, tooltipSave }: EditSellerInfoProps) {
    let [text, setText] = React.useState(value);
    
    return (
        <Box sx={{ display: 'flex', padding: '16px 0' }}>
            <TextField autoFocus value={text} onChange={(event: React.ChangeEvent) => {
                setText((event.target as HTMLInputElement).value);
            }} />
            <Box sx={{ padding: '4px' }}></Box>
            <Tooltip title={tooltipCancel}>
                <IconButton
                    aria-label="Cancel"
                    size="small"
                    onClick={() => {
                        onCancel();
                    }}
                >
                    <CancelIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title={tooltipSave}>
                <IconButton
                    aria-label="Save"
                    size="small"
                    onClick={() => {
                        onSave(text);
                    }}
                >
                    <SaveIcon />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
